import { render, staticRenderFns } from "./forecast.vue?vue&type=template&id=5f64f2cc&scoped=true&"
import script from "./forecast.vue?vue&type=script&lang=js&"
export * from "./forecast.vue?vue&type=script&lang=js&"
import style0 from "./forecast.vue?vue&type=style&index=0&id=5f64f2cc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f64f2cc",
  null
  
)

export default component.exports